import subModuleKeys from '@/modules/constants/subModuleKeys';

export default {
  computed: {
    editEventBaseRoute() {
      return {
        name: subModuleKeys.MANAGE_EVENT_BASE(this.$route.meta.baseName),
        params: {
          ...this.$route.params,
        },
      };
    },
    editEventInfoRoute() {
      return {
        name: subModuleKeys.MANAGE_EVENT_BASIC_INFO(this.$route.meta.baseName),
        params: {
          ...this.$route.params,
        },
      };
    },
    editPricingRoute() {
      return {
        name: subModuleKeys.MANAGE_EVENT_PRICING(this.$route.meta.baseName),
        params: {
          ...this.$route.params,
        },
      };
    },
    editVenueRoute() {
      return {
        name: subModuleKeys.MANAGE_EVENT_VENUE(this.$route.meta.baseName),
        params: {
          ...this.$route.params,
        },
      };
    },
    editReviewRoute() {
      return {
        name: subModuleKeys.MANAGE_EVENT_REVIEW(this.$route.meta.baseName),
        params: {
          ...this.$route.params,
        },
      };
    },
  },
  methods: {
    getRouterPath(key) {
      return { name: key };
    },
    redirectToCreateEvent() {
      this.$router.push(this.getCreateEventRoute());
    },
    getCreateEventRoute() {
      return {
        name: subModuleKeys.CREATE_EVENT,
      };
    },
    getBasicInfoRoute(event) {
      return {
        name: subModuleKeys.MANAGE_EVENT,
        params: {
          eventId: event.id,
        },
      };
    },
    getEventBrandingRoute(event) {
      return {
        name: subModuleKeys.WEB_DESIGN,
        params: {
          eventId: event.id,
        },
      };
    },
    getEventTicketDesignRoute(event) {
      return {
        name: subModuleKeys.TICKET_DESIGN,
        params: {
          eventId: event.id,
        },
      };
    },
    getPricingRoute(event) {
      return {
        name: subModuleKeys.PRICING,
        params: {
          eventId: event.id,
          showId: event.showId,
        },
      };
    },
    getArenaSeatingRoute(event) {
      return {
        name: subModuleKeys.ARENA_SEATING,
        params: {
          eventId: event.id,
          showId: event.showId,
        },
      };
    },
    getSaleLinksRoute(event) {
      return {
        name: subModuleKeys.SALES_LINKS,
        params: {
          eventId: event.id,
        },
      };
    },
    getSalesPulseRoute() {
      return {
        name: subModuleKeys.SALES_TREND,
      };
    },
  },
};
